// Vuex dispatch logic is overriding the params sent for each dispach call. for example if dispach has been fired and action function had to wait for async call,
// if in the waiting time another dispatch of the same type has been fire, the params of the previous dispach will be instantly override by the latest dispatch that been fired.

// our solution is to wrap every action with outter function that will shallow copy the params sent and forward the params to the actual function as a cloned that cannot be manipulate by Vuex

export const actionsInterceptor = (originActions = {}) =>
  Object.keys(originActions).reduce(
    (newActions, action) => ({
      ...newActions,
      [action](...args) {
        // this is the function vuex will trigger for the dispatch
        const shallowCopyArgs = [];
        for (let index = 1; index < args.length; index++) {
          // map and spread the rest of the args to create shallow pointer to prevent override by the Vuex inner logic
          if (Array.isArray(args[index])) shallowCopyArgs.push([...args[index]]);
          else if (typeof args[index] === 'object') shallowCopyArgs.push({ ...args[index] });
          else shallowCopyArgs.push(args[index]);
        }
        return originActions[action].call(
          // now we fire the real desired action function we orginaly created with the following manipulations
          this, // the real vue app this, so the followed action will have access to the app scope.
          args[0], // vuex options sent to us in the first param {commit,dispatch,getters...}
          ...shallowCopyArgs,
        );
      },
    }),
    {},
  );

export const modulesPreProccess = originModules =>
  Object.keys(originModules).reduce((newModules, key) => ({ ...newModules, [key]: { ...originModules[key], actions: actionsInterceptor(originModules[key]?.actions) } }), {});
